import { useParams } from "react-router-dom";
import { ContributorHome } from "@/features/contributor-home/ContributorHome";
import { useApp } from "@/hooks/use-app-context";
import { normalizeUserRole } from "@/lib/auth/roles";
import { PublicHome } from "./PublicHome";

/**
 * /:lang and /:lang/dashboard: a signed-in contributor or collector gets their
 * own home (earnings, next step, tasks); everyone else the public page.
 * Back-office roles never get here: OwnSpaceOnly sends them to their panel.
 */
export function HomeRoute() {
  const { user, isAuthenticated } = useApp();
  const { lang = "fr" } = useParams<{ lang: string }>();
  const role = user ? normalizeUserRole(user.role) : null;
  if (isAuthenticated && (role === "user" || role === "collector")) {
    return <ContributorHome lang={lang} />;
  }
  return <PublicHome />;
}
